import React from 'react';
import styles from './Label.module.css';

/**
 * Компонент Label с двумя строками по вертикали
 * @param {string} topText - Текст верхней строки (белый цвет)
 * @param {string} bottomText - Текст нижней строки (accent цвет)
 * @param {string} shift - Смещение нижней строки (small, medium, large)
 * @param {string} className - Дополнительные CSS классы
 */
const Label = ({ 
  topText, 
  bottomText, 
  shift = 'small', 
  className = '',
  ...props 
}) => {
  console.log('Отрисовка компонента Label:', topText, bottomText);
  
  return (
    <div className={`${styles.label} ${className}`} {...props}>
      <div className={styles.labelContainer}>
        <div className={styles.topText}>{topText}</div>
        <div className={`${styles.bottomText} ${styles[`shift-${shift}`]}`}>
          {bottomText}
        </div>
      </div>
    </div>
  );
};

export default Label; 